import {
  DEFAULT_LANG,
  LANG_NAMESPACES,
  LANG_STORAGE_KEY,
  LANGS_KEYS,
} from '@compliance/constants/language'
import { LanguageTypes } from '@compliance/types'
import { I18nManager } from '@caudena/core/utils/i18next'

const i18next = new I18nManager<LanguageTypes>({
  namespaces: LANG_NAMESPACES,
  fallbackLng: DEFAULT_LANG,
  supportedLanguages: LANGS_KEYS,
})

function isJson(str: string) {
  try {
    JSON.parse(str)
    return true
  } catch {
    return false
  }
}

const lang = localStorage.getItem(LANG_STORAGE_KEY) || DEFAULT_LANG

i18next.initialize(isJson(lang) ? JSON.parse(lang) : (lang as LanguageTypes))

export { i18next }
